import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { GoSuiteApp } from "go-app/services/types";
import { isAppInstalled } from "go-core/components/Apps/AppUtils";
import { redirectToApplication } from "go-core/utils/utils";
import { selectOrganization } from "../../../../../../../services/organizations/selectors";

interface Props {
	application: GoSuiteApp;
}

const OrganizationDashboardApplicationCard = ({ application }: Props) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const organizationApplication = organization.applications.filter(
		(app) => app.slug === application.id.toUpperCase()
	)[0];
	const appUrl = redirectToApplication(application.url, application.old ? "" : organization.company_id);

	if (application.id.toLowerCase() === "goaccounts") return null;

	return (
		<div className="col mb-3">
			<Card className="application-card">
				{appUrl && <a className="stretched-link card-link" href={appUrl}></a>}
				<Card.Body className="position-relative">
					<Card.Title>
						<img
							className="application-img"
							src={`graphics/apps/${application.id.toLowerCase()}.png`}
							alt={application.id}
						/>{" "}
						{application.name}
						{isAppInstalled(application, !!organizationApplication) ? (
							<Button variant="primary" type="button">
								{t("lib:common.action.goto")}
							</Button>
						) : (
							<Button variant="add" type="button">
								{t("lib:common.action.install")}
							</Button>
						)}
					</Card.Title>
					<Card.Text>{t(`lib:enum.apps.${application.id}.header`)}</Card.Text>
				</Card.Body>
			</Card>
		</div>
	);
};

export default OrganizationDashboardApplicationCard;
